module.exports = __webpack_public_path__ + "img/login_bg.b64c23ba.png";